<template>
  <v-dialog v-model="loadingDialog" persistent width="40%">
    <v-card class="pa-1" color="cardbg">
      <v-card-text>
        <v-row no-gutters="">
          <v-col cols="12" class="pb-2 mt-2">
            <h2 class="headline font-weight-bold black--text pb-2">
              {{ text }}
            </h2>
          </v-col>
          <v-col cols="12">
            <v-progress-linear
              color="primary"
              :indeterminate="loadingDialog"
              class="mb-2 mt-2"
            ></v-progress-linear>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {},
  computed: {
    loadingDialog() {
      return this.$store.getters["loading/loadingDialog"];
    },
    text() {
      let msg = this.$store.getters["loading/loadingMsg"];
      let translatedText = this.$t(msg);
      return (
        translatedText || this.$t("dialogs.loading.contentLoadingDialogMsg")
      );
    }
  }
};
</script>
